(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["solfetti-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  var hero = document.querySelector('.sf7-hero');
  var canvas = document.getElementById('sf7Fluid');
  var sparks = document.getElementById('sf7Sparks');
  if (!hero || !canvas) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (sparks) {
    for (var sparkIndex = 0; sparkIndex < 18; sparkIndex += 1) {
      var spark = document.createElement('i');
      spark.style.setProperty('--spark-left', 5 + Math.random() * 90 + '%');
      spark.style.setProperty('--spark-size', 3 + Math.random() * 6 + 'px');
      spark.style.setProperty('--spark-duration', 4.5 + Math.random() * 4 + 's');
      spark.style.setProperty('--spark-delay', -Math.random() * 7 + 's');
      sparks.appendChild(spark);
    }
  }
  var context = canvas.getContext('2d');
  var width = 0;
  var height = 0;
  var frame = 0;
  var pointerX = 0.5;
  var pointerY = 0.5;
  var smoothX = 0.5;
  var smoothY = 0.5;
  var palette = ['#F4B860', '#E58E68', '#C25E3C', '#E8A24C', '#D98A5E', '#F2C98A'];
  var blobs = Array.from({ length: 10 }, function (_, index) {
    return { x: Math.random(), y: Math.random(), radius: 0.28 + Math.random() * 0.28, speed: 0.12 + Math.random() * 0.22, phase: Math.random() * Math.PI * 2, color: palette[index % palette.length] };
  });
  function resizeCanvas() {
    var rect = canvas.getBoundingClientRect();
    var ratio = Math.min(window.devicePixelRatio || 1, 1.6);
    width = canvas.width = Math.max(2, Math.round(rect.width * ratio));
    height = canvas.height = Math.max(2, Math.round(rect.height * ratio));
  }
  function draw(time) {
    smoothX += (pointerX - smoothX) * 0.045;
    smoothY += (pointerY - smoothY) * 0.045;
    context.clearRect(0, 0, width, height);
    blobs.forEach(function (blob) {
      var x = (blob.x + Math.cos(time * blob.speed + blob.phase) * 0.15 + (smoothX - 0.5) * 0.24) * width;
      var y = (blob.y + Math.sin(time * blob.speed * 1.08 + blob.phase) * 0.15 + (smoothY - 0.5) * 0.24) * height;
      var radius = blob.radius * Math.min(width, height) * (1 + Math.sin(time * blob.speed + blob.phase) * 0.08);
      var gradient = context.createRadialGradient(x, y, 0, x, y, radius);
      gradient.addColorStop(0, blob.color + 'd9');
      gradient.addColorStop(1, blob.color + '00');
      context.fillStyle = gradient;
      context.beginPath();
      context.arc(x, y, radius, 0, Math.PI * 2);
      context.fill();
    });
  }
  function animate(timestamp) {
    draw(timestamp / 1000);
    frame = window.requestAnimationFrame(animate);
  }
  resizeCanvas();
  window.addEventListener('resize', resizeCanvas, { passive: true });
  hero.addEventListener('pointermove', function (event) {
    var rect = hero.getBoundingClientRect();
    pointerX = (event.clientX - rect.left) / rect.width;
    pointerY = (event.clientY - rect.top) / rect.height;
  }, { passive: true });
  window.addEventListener('scroll', function () {
    var distance = Math.min(window.scrollY, window.innerHeight);
    hero.style.setProperty('--hero-fluid-shift', distance * 0.08 + 'px');
    hero.style.setProperty('--hero-sun-shift', distance * 0.04 + 'px');
    hero.style.setProperty('--hero-text-shift', distance * -0.035 + 'px');
  }, { passive: true });
  if (reduceMotion) draw(0);
  else frame = window.requestAnimationFrame(animate);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) window.cancelAnimationFrame(frame);
    else if (!reduceMotion) frame = window.requestAnimationFrame(animate);
  });
}());

  } catch(e) { console.error(e); }
})();
})();
